import classNames from 'classnames';
import React from 'react';

import './Card.css';

export default ({ children, disablePadding }) => (
  <div
    className={classNames('Card', {
      'Card--no-padding': disablePadding,
    })}
  >
    {children}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/timeline/Card.js